import logo from './logo.svg';
import './App.css';

import Questionnaire from './questionnaire';

function App() {
  return (
    <div className="App">
      <h1>Formulaire Multi-Étapes</h1>
      <Questionnaire />
    </div>
  );
}

export default App;
